// index.js
import React from 'react';
import { createRoot } from 'react-dom/client';
import axios from 'axios';
import App from './App';

// The backend runs on another port/sub-domain; the session cookie (admin login,
// permissions) must go with every API request.
axios.defaults.withCredentials = true;

// One clear message when the server refuses an admin action, instead of each page's
// generic "something went wrong".
let lastNotice = 0;
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const data = error.response && error.response.data;
    const code = data && data.code;
    if ((code === 'FORBIDDEN' || code === 'NOT_LOGGED_IN') && Date.now() - lastNotice > 3000) {
      lastNotice = Date.now();
      if (code === 'FORBIDDEN') {
        window.alert(data.error);
      } else if (localStorage.getItem('role') === 'admin') {
        window.alert('Your admin session has ended. Please log in again.');
        localStorage.removeItem('role');
        localStorage.removeItem('username');
        window.location.href = '/';
      }
    }
    return Promise.reject(error);
  }
);

const root = createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
